
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sellers/new",
      function () {
        return require("private-next-pages/sellers/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sellers/new"])
      });
    }
  